
    <div>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <button mat-raised-button color="primary" (click)="onDone()">{{ button_text }}</button>
    </div>
  